/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa LocalStorageImplementation
 *
 */

Intesa.LocalStorageImplementations = function () {

var LocalStorageImplementation = this;


this.init = function (){
    console.log("LocalStorageImplementations");
    LocalStorageImplementation.getSourceUrl();
};



this.getSourceUrl = function () {
    var isSourceUrl = $("#sourceUrlPage").length > 0;
    if( isSourceUrl ){
        var sourceUrlPageVal = $("#sourceUrlPage").val();
        localStorage.setItem("sourceUrlPage", sourceUrlPageVal);
        var isSourceUrlInput = $("[name='sourceUrl']").length > 0;
        if (isSourceUrlInput){
            LocalStorageImplementation.setSourceUrl(sourceUrlPageVal);
        }
    }else{
        var sourceUrlPageFromStorage = localStorage.getItem("sourceUrlPage") != null ? localStorage.getItem("sourceUrlPage") : "";
        LocalStorageImplementation.setSourceUrl(sourceUrlPageFromStorage);
    }
}


this.setSourceUrl = function(sourceUrlPageVal){
    var sourceUrlInput = $("[name='sourceUrl']");
    sourceUrlInput.each(function () {
    $(this).val(sourceUrlPageVal);
    });
}


};
 
 /**
  * Get class instance
  *
  */
Intesa.LocalStorageImplementations.getInstance = function () {

    if (!window.intesa) {

        window.intesa = new Object();

    }
    if (!window.intesa.LocalStorageImplementations) {

        window.intesa.LocalStorageImplementations = new Intesa.LocalStorageImplementations();

    }

    return window.intesa.LocalStorageImplementations;

};
 